module.exports = __webpack_public_path__ + "static/media/porady-ekspertow-icon.40112c76.svg";